import {
    FETCH_MOTOR_ACTION_LOGS,
    RESET_MOTOR_ACTION_LOGS,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {
      total: 0,
      offset: 0,
      limit: 10,
    },
  };
  
  const motorActionLogsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MOTOR_ACTION_LOGS:
        return { list: action.payload, others: action.others };
      case RESET_MOTOR_ACTION_LOGS:
        return initialState;
      default:
        return state;
    }
  };
  
  export default motorActionLogsReducer;
  